import script from "./AdminQuestionManager.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminQuestionManager.vue?vue&type=script&setup=true&lang=js"

import "./AdminQuestionManager.vue?vue&type=style&index=0&id=7e3f8dfe&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e3f8dfe"]])

export default __exports__